
// '',
let logos = [

  '                                                                                                                                                 \n' +
  '                                                                                                                                                 \n' +
  '           :BBQ.                     P1          rQBZ                                                                                            \n' +
  '           .BB2                     iBBBd        .BBr                                             :::.                :::.                       \n' +
  '            BB.      sQbERRMXgb       :BBBK       BB                                          iQBBBBQBBBD.        7BBBQBBBBBQr       BBBi        \n' +
  '       DgI15BBZL1vK7 sBBQMQgBBB         iE .i.::.rBBr.:::ir                                  BBBBJ: .:bBBBQ     :BBQBY:..:1BBBB      BBB:        \n' +
  '       BBBBBBBQBQBBq rBB    dBd    BB7     BQBBBBBBBBBBBBBB                                 BBBd        BBR    .BBBi        vBBB     BBB.        \n' +
  '            BB   BBr rBB    MBD   .PBQBQi  UBB    BB    RBd                                vBBB                BBBj          PBBQ    RBB         \n' +
  '           .BB   BQ: rBB    RBE      .EBb  UBB    BB    PBq                                BQBJ                BBB           .BBB    MBB         \n' +
  '           7BB   BB. rBB    QQD         Y. JBBiiivBBY:i:BQb                                BBB7     DEbqIuSr  .BBQ            BBB    dBQ         \n' +
  '           gQB   BB. rBB    RBE         BB 7BBBBBBBBQBQBBBq                                QBBY     BBBBBBBQ   BBB           .BBB    gBB         \n' +
  '           BBI  .BB  rBQ    MBZ        BBB LBB    BB    gBb                                LBQB         iQBK   BBBv          IBBB    1BB         \n' +
  '          UBB   :BQ  rQB    bBd       JBB  UBB    BB    DBP       LBBBM                     BBBq        iBBZ   iBBQ.        :BQB.                \n' +
  '          BB5   :BB  rBBBBBBBBE      .BB7  1BB    BB    DBP       EBBQB                      BBQBi    .IBBB1    rBBBg.    :gBBB.     DQQ:        \n' +
  '         BBB .  DBB  7QB777rBBM     .BBB   IBBQBBBBBBBQBBBP       7MBBB                       vBBBBBBBQBBP        KBBBBBBBBBBj       BQB7        \n' +
  '       7BBB  ZBQBBY  SBQ    BBB     BBB    EBBSSP2YvIXK2BBB        rBBr                          :s12v:              :suUv:          ...         \n' +
  '      rBBB    j7.    .:i             rI    EQB          IDI       :Bg.                                                                           \n' +
  '                                                                                                                                                 \n' +
  '                                                                                                                                                 \n',


  '                                                                                                                                                   \n' +
  '               g2J                 :                    .                                                                                    . .   \n' +
  '          YBBB BQB qB.            BBB7 gBE              BBBBBBBBBBQBBBQBBBBBBBB1     Uv7 rBBLr::.:iii:.:7r    .BQQgMXEj  BQBBBBBBBBB        :BBBq  \n' +
  '   dBQBQBBBBEX:QBU PBBB.         7BQj   gBBiBBBBBBBB.   ..      BQ.  UBQ      .      BBQ  BB.BBBBBBQBBBBB:    .BBBQgBBE  QBJ::::.QBB        .BBBs  \n' +
  '    :i  QBv    dBZ   KBB         BBP  Yr.RBX.... vBB      .ZuqXPQBZS2BBB5bK1b:       BQu .BB   BBZ   IBB.           MB1  BQ.     qBB         BBBr  \n' +
  '  .     QB2    SBQ    :. .      BBB   BBB        .BB      iBB2vsBBS77MBBvv2BBi       BBj  BB    MBQ EQB        .    BB2  BBBBBBBBBBB         BBBi  \n' +
  '  BBBBQBBBBBBBBBBBBBBBBBBB     BBBB   ZBZ        :QB      .BB   BB   LBM   BB:       BBU .BB     PBBBg         BBBBBQBP      BBP             BBB:  \n' +
  '  .     BB1    :BB   Rr      jBBBBB   DQM        :BB      rBBBBBBBBBBBBQBBBBBv       QB1 .BB  :UBBBDBBBj.      BBi     :BQBBBBBBBQBBB        BBB:  \n' +
  '        QBr  Y  BB  7BQq    .BBK.BB   EBg        :BB             ZBB.                BBg .BBgBBBgi   7BBBBJ    BB.     .BBr::BBJ.:QBB        BBB.  \n' +
  '        BBBBBBi BQ7 BB7         .QB   DBR        :BB    BQEIS2JrSBBB5us7vJS55PBQ     ri  .Bg .BBr       ui    iBBBBBBBr BB   BB   rBQ        BBB.  \n' +
  '  .:7ZBBQBB7    :BBBBu          :BB   ZBM        iBB    BBBBQdRBBQ7IdKRBQBQBQBBB              BB7  .          .: . .QB..QBQBRBBBRQQBB        BBB   \n' +
  '  sBBBE.BQs      BBBi           :BB   gBR        :BQ          BBB     EBQ             :BBBBBBBBBBBBBBBBg            BB  KJSIIBBP1sL1r        BBB   \n' +
  '   .    QB2     RBBB:   .       :BB   ZBM        :BB         :u2PBQBZBBM                      BB.                   BB       BB   DB         rLv   \n' +
  '        BBK  .BBBv.BBL  BB:     :BB   DBQ        .BB            .5BBBQBBBBdi                  BB.               .  2BB      .QBKisBBB.       :::   \n' +
  '    .QSuBB1:QBBP   .BBBBBB      iBQ   BBB     QBEBQB     qQBQBBBQBK:   .LBBBBB     BBBBBBBBBBBBBBBQBQBQBBBR    :BBBBQ. BQBBBBBBBBBSBBB.      BQBj  \n' +
  '     BBBBu  .7       vBBB       JBB.  QBR     iBBBD:      RBb1r             U5     .i.........  ........::.     is:    .r.          P7.      BBBi  \n',


  '                                                                                                                                                   \n' +
  '                :Qr:.                                                       .:                                                                     \n' +
  '                5BBBBs                                     :jZBQ.           gBBBBI           R5.              ZBSjv.                   rIsjJS.     \n' +
  '       .        BBQB                         i:..::rubDQBBBBBBQBBu          rBBBg           UBBBB2           :QBBBBI                   QBBBBBL     \n' +
  '       BBBBBBBBQBQBBBBBBBQBQBBBBBBQ          UBQBQBBBBBBBBBBDuvi1Y          :QBBv          .BQBQj            BBQBB7                    5BBBBBi     \n' +
  '       BBBBBBQggDgggbZDQBQDQBBBBBB1           5BBBDI7::BBBP                 :BBB7          BBBB             QBBBBBQj                   LBBBBB.     \n' +
  '       EBBE   7    Dq2S  ..    BBBr                    BBBD         RBBBB.  :BBBv         PBBB.   RBX.     QBQB7.BBBg                  rBQBBB.     \n' +
  '       DBBg .BBBP  BQBD :BBBQ  BBBi                    BBBd         vBQBX   :BBBv        YBBBr   7BBBBB   BBBBu  .QBQB:                iBBQBB.     \n' +
  '       ZBBR   MQB1 QBB  BBBi   BBBr          .         BBBb      .. iBBBi   :BBBL       iBBB:   :BBBBv  :QBBBr     MBBBD               :BBBBB      \n' +
  '       gBBE i:iBq..BQBL :QZ.i. BBBi         vBBBBBBBBBBBBBBBBBBBQBB .BBBr   :BBB7      LBBBP   iBBBB   2BBBg        .BBBBQ:            .BBBBB      \n' +
  '       ZBBP BBBBBQBBBBBQBQBBBZ BBBr         rBBQBBBBBDBQBBBPgBBBBBB :BBQr   :BBBv     RBBBBBBBBBBBB  iBBBBB7.i77v77i.rBBBBBBgv:        .BBBBB      \n' +
  '       gBBE .   YBBBBBr7BJ     BBBi                   BBBBQr        iBBBi   :BQBv      BBBgPvMBBBB.7QBQBBBBBBBBBBBBBBBBBRBBBQBv         BBBBB      \n' +
  '       EBQM    qBBBQBBXBBBBi   BBBi                 .BBQBBBBBq      iBBBr   :BBBv            DBQB  iRBBP rs7rr7r7r7rr7Ls  2BP           BBBQB      \n' +
  '       DBBg sBBBBJ BBB: 7BBBQi BBBi                :QBBBBBBBBBBR.   iBBBr   :BBBv          .BBBB      .                                 QBQBB      \n' +
  '       ZBQg.BBBD   QQBr   SBZ  BBBY               7BBBBBBBX 7QBBBQ  rQBBr   :BBBv         JBBBv         :i..............r:              BBBBB      \n' +
  '       BBBB  .    .v.         :BBBS              XQBBQ QBBE   QBQL  iBBBi   :BQBv      .JBBBBBvjdBBBBB: QBBBBBBBBBBBQBQBBM              BBBBM      \n' +
  '   :.  77r7       RBBBBi              :.       .BQBBQ  BBBg    ur   rBBBr   :BBBv      YBBBBBBBBBBBBBB  vQBBgSdbEddPXgBBB7              BQBBQ      \n' +
  '  1BQBBBQBBBBBBBBBBBBBBBBBBBBBQBBBBBBBBd      jBBBBX   BBBg         jBBBS   :BBB7       PBBEJ7r:.       :BBB         .QBB7              BBBBP      \n' +
  '  rBBQBQQRQQQMMSdBBBBQBBBg5PRQQRQQQQQBBL    5QBBBBr    BBBM         ZQBQQ   :BBBv                       :BBQ:        :BBB7              BBBBR      \n' +
  '                sBBBPPBBQD                  sgBBB.     BBBg                 :BBBv                .ivPBB .BBB.        .BBBv              vUY2:      \n' +
  '              iBBBBZ  7BBBBQ:                          BBBM                 .BBBL     :::r2SdQBBBBBQBQB .BBQ.        .BBB7                         \n' +
  '           :PBBBBBr     SBBBBBZi                       BQBZ           :     7BBBJ     DBBBBBBBBBBBQdSL. .BBBBBBBBBBBBBBBB7             .BBBBB.     \n' +
  '  ...:vugBBBBBBBv         7BBBBBBQQjv:..               BBBB           BBBQBBBBBBi      BBBBdvi.         rBBBBBBBBBBQBBBBB7             .BBBBB.     \n' +
  '  :BBBBBBBQBBJ.              LQBBBBBBBBJ              :BBBB           .BBBQBBBQ7        .               qBBBv        jBBBE             :QBBBQ.     \n' +
  '    BBBBMs:                     :JBBBB.               .5UuI            :r..                             72U1i         ....              SuJjS      \n' +
  '     :                              .                                                                                                              \n' +
  '                                                                                                                                                   \n',


  '                .-~~~~~~~~~-._       _.-~~~~~~~~~-.\n' +
  '            __.\'              ~.   .~              `.__\n' +
  '          .\'//                  \\./                  \\\\`.\n' +
  '        .\'//                     |                     \\\\`.\n' +
  '      .\'// .-~"""""""~~~~-._     |     _,-~~~~"""""""~-. \\\\`.\n' +
  '    .\'//.-"                 `-.  |  .-\'                 "-.\\\\`.\n' +
  '  .\'//______.============-..   \\ | /   ..-============.______\\\\`.\n' +
  '.\'______________________________\\|/______________________________`.\n' +
  '\n',


  '              ,----------------,              ,---------,\n' +
  ' *         ,-----------------------,          ,"        ,"|\n' +
  ' *       ,"                      ,"|        ,"        ,"  |\n' +
  ' *      +-----------------------+  |      ,"        ,"    |\n' +
  ' *      |  .-----------------.  |  |     +---------+      |\n' +
  ' *      |  |                 |  |  |     | -==----\'|      |\n' +
  ' *      |  |  I LOVE DOS!    |  |  |     |         |      |\n' +
  ' *      |  |  Bad command or |  |  |/----|`---=    |      |\n' +
  ' *      |  |  C:\\>_          |  |  |   ,/|==== ooo |      ;\n' +
  ' *      |  |                 |  |  |  // |(((( [33]|    ,"\n' +
  ' *      |  `-----------------\'  |," .;\'| |((((     |  ,"\n' +
  ' *      +-----------------------+  ;;  | |         |,"\n' +
  ' *         /_)______________(_/  //\'   | +---------+\n' +
  ' *    ___________________________/___  `,\n' +
  ' *   /  oooooooooooooooo  .o.  oooo /,   \\,"-----------\n' +
  ' *  / ==ooooooooooooooo==.o.  ooo= //   ,`\\--{)B     ,"\n' +
  ' * /_==__==========__==_ooo__ooo=_/\'   /___________,"\n' +
  ' *',

  '                       d*##$.\n' +
  ' zP"""""$e.           $"    $o\n' +
  '4$       \'$          $"      $\n' +
  '\'$        \'$        J$       $F\n' +
  ' \'b        $k       $>       $\n' +
  '  $k        $r     J$       d$\n' +
  '  \'$         $     $"       $~\n' +
  '   \'$        "$   \'$E       $\n' +
  '    $         $L   $"      $F ...\n' +
  '     $.       4B   $      $$$*"""*b\n' +
  '     \'$        $.  $$     $$      $F\n' +
  '      "$       R$  $F     $"      $\n' +
  '       $k      ?$ u*     dF      .$\n' +
  '       ^$.      $$"     z$      u$$$$e\n' +
  '        #$b             $E.dW@e$"    ?$\n' +
  '         #$           .o$$# d$$$$c    ?F\n' +
  '          $      .d$$#" . zo$>   #$r .uF\n' +
  '          $L .u$*"      $&$$$k   .$$d$$F\n' +
  '           $$"            ""^"$$$P"$P9$\n' +
  '          JP              .o$$$$u:$P $$\n' +
  '          $          ..ue$"      ""  $"\n' +
  '         d$          $F              $\n' +
  '         $$     ....udE             4B\n' +
  '          #$    """"` $r            @$\n' +
  '           ^$L        \'$            $F\n' +
  '             RN        4N           $\n' +
  '              *$b                  d$\n' +
  '               $$k                 $F\n' +
  '                $$b                $F\n' +
  '                 $""               $F\n' +
  '                 \'$                $\n' +
  '                  $L               $\n' +
  '                  \'$               $\n' +
  '                   $               $\n',


  '                  /88888888888888888888888888\\\n' +
  '                  |88888888888888888888888888/\n' +
  '                   |~~____~~~~~~~~~"""""""""|\n' +
  '                  / \\_________/"""""""""""""\\\n' +
  '                 /  |              \\         \\\n' +
  '                /   |  88    88     \\         \\\n' +
  '               /    |  88    88      \\         \\\n' +
  '              /    /                  \\        |\n' +
  '             /     |   ________        \\       |\n' +
  '             \\     |   \\______/        /       |\n' +
  '  /"\\         \\     \\____________     /        |\n' +
  '  | |__________\\_        |  |        /        /\n' +
  '/""""\\           \\_------\'  \'-------/       --\n' +
  '\\____/,___________\\                 -------/\n' +
  '------*            |                    \\\n' +
  '  ||               |                     \\\n' +
  '  ||               |                 ^    \\\n' +
  '  ||               |                | \\    \\\n' +
  '  ||               |                |  \\    \\\n' +
  '  ||               |                |   \\    \\\n' +
  '  \\|              /                /"""\\/    /\n' +
  '     -------------                |    |    /\n' +
  '     |\\--_                        \\____/___/\n' +
  '     |   |\\-_                       |\n' +
  '     |   |   \\_                     |\n' +
  '     |   |     \\                    |\n' +
  '     |   |      \\_                  |\n' +
  '     |   |        ----___           |\n' +
  '     |   |               \\----------|\n' +
  '     /   |                     |     ----------""\\\n' +
  '/"\\--"--_|                     |               |  \\\n' +
  '|_______/                      \\______________/    )\n' +
  '                                              \\___/\n' +
  '\n',


  '░░░░░░░░░░░░░░░░░░░░░░░░▄░░\n' +
  '░░░░░░░░░▐█░░░░░░░░░░░▄▀▒▌░\n' +
  '░░░░░░░░▐▀▒█░░░░░░░░▄▀▒▒▒▐\n' +
  '░░░░░░░▐▄▀▒▒▀▀▀▀▄▄▄▀▒▒▒▒▒▐\n' +
  '░░░░░▄▄▀▒░▒▒▒▒▒▒▒▒▒█▒▒▄█▒▐\n' +
  '░░░▄▀▒▒▒░░░▒▒▒░░░▒▒▒▀██▀▒▌\n' +
  '░░▐▒▒▒▄▄▒▒▒▒░░░▒▒▒▒▒▒▒▀▄▒▒\n' +
  '░░▌░░▌█▀▒▒▒▒▒▄▀█▄▒▒▒▒▒▒▒█▒▐\n' +
  '░▐░░░▒▒▒▒▒▒▒▒▌██▀▒▒░░░▒▒▒▀▄\n' +
  '░▌░▒▄██▄▒▒▒▒▒▒▒▒▒░░░░░░▒▒▒▒\n' +
  '▀▒▀▐▄█▄█▌▄░▀▒▒░░░░░░░░░░▒▒▒\n' +
  '单身狗就这样默默地看着你，一句话也不说。\n',


  '頂頂頂頂頂頂頂頂頂　頂頂頂頂頂頂頂頂頂\n' +
  '頂頂頂頂頂頂頂　　　　　頂頂　　　　　\n' +
  '　　　頂頂　　　頂頂頂頂頂頂頂頂頂頂頂\n' +
  '　　　頂頂　　　頂頂頂頂頂頂頂頂頂頂頂\n' +
  '　　　頂頂　　　頂頂　　　　　　　頂頂\n' +
  '　　　頂頂　　　頂頂　　頂頂頂　　頂頂\n' +
  '　　　頂頂　　　頂頂　　頂頂頂　　頂頂\n' +
  '　　　頂頂　　　頂頂　　頂頂頂　　頂頂\n' +
  '　　　頂頂　　　頂頂　　頂頂頂　　頂頂\n' +
  '　　　頂頂　　　　　　　頂頂頂　\n' +
  '　　　頂頂　　　　　　頂頂　頂頂　頂頂\n' +
  '　頂頂頂頂　　　頂頂頂頂頂　頂頂頂頂頂\n' +
  '　頂頂頂頂　　　頂頂頂頂　　　頂頂頂頂\n',


  '  .--,       .--,\n' +
  ' ( (  \\.---./  ) )\n' +
  '  \'.__/o   o\\__.\'\n' +
  '     {=  ^  =}\n' +
  '      >  -  <\n' +
  '     /       \\\n' +
  '    //       \\\\\n' +
  '   //|   .   |\\\\\n' +
  '   "\'\\       /\'"_.-~^`\'-.\n' +
  '      \\  _  /--\'         `\n' +
  '    ___)( )(___\n' +
  '   (((__) (__)))    高山仰止,景行行止.虽不能至,心向往之。\n' +
  '/\n',


  '\n' +
  '                                `:::::::::::,\n' +
  '                            `::;:::::::;:::::::,  `\n' +
  '                         `::;;:::::::@@@@;:::::::`\n' +
  '                       ,:::::::::::::@    #@\':::::`\n' +
  '                     :::::::::::::::\'@@      @;::::\n' +
  '                   ::::::::::::\'@@@@\'```      .+:::`\n' +
  '                 ::::::::::;@@@#.              ,:::,\n' +
  '               .::::::::+@#@`                   ::::\n' +
  '              :::::::+@@\'                       ::::\n' +
  '            `:::::\'@@:                         `:::.\n' +
  '           ,::::@@:  `                         ::::\n' +
  '          ;::::::@                            .:::;\n' +
  '         :;:::::;@`        `                  :::;\n' +
  '        :::::::::@`        @                 ;::::\n' +
  '       :::::::::#`          @`              ,::::\n' +
  '      :::::::::@`         +@ @             .::::`\n' +
  '     .::::::\'@@`       `@@\'  @             ::::,\n' +
  '     :::::::++@@@@@@@@@@.                 ::::;\n' +
  '    ;:::::::+,   `..`                    :::::\n' +
  '   ,::::::::\',                          :::::\n' +
  '   :::::::::+,                         :::::`\n' +
  '  :::::::::+@.                        ,::::.`                     `,\n' +
  '  ::::::;;@+                         .::;::                     `;\n' +
  ' :::::::@@                          `:::;:                   `::``\n' +
  ' ::::::#@                           ;::::                  .::`\n' +
  ' :::::;@                           :::::`               .;::`\n' +
  ' :::::@                           `:;:::            `::::;\n' +
  ' :::::#                           :::::.        `,;:::::\n' +
  ' ::::::                    `      ::::::,.,::::::::::.\n' +
  ' ,::::::`              .::        ::::::::::::::::;`\n' +
  '  ;::::::::,````.,:::::,          ::::::::::::::.\n' +
  '   :::::::::::::::::: `           `::::::::::`\n' +
  '    `::::::::::::,                  .:::.\n' +
  '        `..`\n',



  '          _.._        ,------------.\n' +
  '       ,\'      `.    ( We want you! )\n' +
  '      /  __) __` \\    `-,----------\'\n' +
  '     (  (`-`(-\')  ) _.-\'\n' +
  '     /)  \\  = /  (\n' +
  '    /\'    |--\' .  \\\n' +
  '   (  ,---|  `-.)__`\n' +
  '    )(  `-.,--\'   _`-.\n' +
  '   \'/,\'          (  Uu",\n' +
  '    (_       ,    `/,-\' )\n' +
  '    `.__,  : `-\'/  /`--\'\n' +
  '      |     `--\'  |\n' +
  '      `   `-._   /\n' +
  '       \\        (\n' +
  '       /\\ .      \\.  freebuf\n' +
  '      / |` \\     ,-\\\n' +
  '     /  \\| .)   /   \\\n' +
  '    ( ,\'|\\    ,\'     :\n' +
  '    | \\,`.`--"/      }\n' +
  '    `,\'    \\  |,\'    /\n' +
  '   / "-._   `-/      |\n' +
  '   "-.   "-.,\'|     ;\n' +
  '  /        _/["---\'""]\n' +
  ' :        /  |"-     \'\n' +
  ' \'           |      /\n' +
  '             `      |\n' +
  '\n',


  '         _____                    _____                    _____                    _____          \n' +
  '        /\\    \\                  /\\    \\                  /\\    \\                  /\\    \\         \n' +
  '       /::\\____\\                /::\\    \\                /::\\    \\                /::\\    \\        \n' +
  '      /:::/    /                \\:::\\    \\              /::::\\    \\              /::::\\    \\       \n' +
  '     /:::/    /                  \\:::\\    \\            /::::::\\    \\            /::::::\\    \\      \n' +
  '    /:::/    /                    \\:::\\    \\          /:::/\\:::\\    \\          /:::/\\:::\\    \\     \n' +
  '   /:::/____/                      \\:::\\    \\        /:::/__\\:::\\    \\        /:::/__\\:::\\    \\    \n' +
  '  /::::\\    \\                      /::::\\    \\      /::::\\   \\:::\\    \\      /::::\\   \\:::\\    \\   \n' +
  ' /::::::\\    \\   _____    ____    /::::::\\    \\    /::::::\\   \\:::\\    \\    /::::::\\   \\:::\\    \\  \n' +
  '/:::/\\:::\\    \\ /\\    \\  /\\   \\  /:::/\\:::\\    \\  /:::/\\:::\\   \\:::\\____\\  /:::/\\:::\\   \\:::\\    \\\n' +
  ':::/  \\:::\\    /::\\____\\/::\\   \\/:::/  \\:::\\____\\/:::/  \\:::\\   \\:::|    |/:::/__\\:::\\   \\:::\\____\\\n' +
  '::/    \\:::\\  /:::/    /\\:::\\  /:::/    \\::/    /\\::/   |::::\\  /:::|____|\\:::\\   \\:::\\   \\::/    /\n' +
  '\\/____/ \\:::\\/:::/    /  \\:::\\/:::/    / \\/____/  \\/____|:::::\\/:::/    /  \\:::\\   \\:::\\   \\/____/\n' +
  '         \\::::::/    /    \\::::::/    /                 |:::::::::/    /    \\:::\\   \\:::\\    \\     \n' +
  '          \\::::/    /      \\::::/____/                  |::|\\::::/    /      \\:::\\   \\:::\\____\\    \n' +
  '          /:::/    /        \\:::\\    \\                  |::| \\::/____/        \\:::\\   \\::/    /    \n' +
  '         /:::/    /          \\:::\\    \\                 |::|  ~|               \\:::\\   \\/____/     \n' +
  '        /:::/    /            \\:::\\    \\                |::|   |                \\:::\\    \\         \n' +
  '       /:::/    /              \\:::\\____\\               \\::|   |                 \\:::\\____\\        \n' +
  '       \\::/    /                \\::/    /                \\:|   |                  \\::/    /        \n' +
  '        \\/____/                  \\/____/                  \\|___|                   \\/____/         \n' +
  '\n',




  ' \n' +
  '　　　１１１　　　　　　　　　　　　　　　　　　　　　　　　　１　　　　　　　　　　　\n' +
  '　　　１１１　１１１１１１１１１１１１　　　　　　　　　　　１１１　　　　　　　　　　\n' +
  '　　　１１　　１１１１１１１１１１１１　　　　　　　　　　１１１１１　　　　　　　　　\n' +
  '　　　１１　　１１１　　　　　　　１１　　　　　　　　　１１１１１１１　　　　　　　　\n' +
  '　１１１１　１　１１１１１１１１１１１　　　　　　　　　１１１　１１１１　　　　　　　\n' +
  '　１１１１１１　１１１１１１１１１１１　　　　　　　１１１１　　　１１１１１　　　　　\n' +
  '　１１１１１１　１１　　　　　　　　　　　　　　　１１１１　　　　　１１１１１１　　　\n' +
  '　　　１１　　　１１１１１１１１　１１　　　　１１１１１１１１１１１１１１１１１１　　\n' +
  '　　　１１　　　１１１１１１１１１１１　　　１１１１１１１１１１１１１１１１１１１　　\n' +
  '　　　１１１１１１１１１　１１　　１１　　　　１１　　　　　　１１　　　　　　　　　　\n' +
  '　１１１１１１１１１１１１１１１１１１　　　　　　　　　　　　１１　　　　　　　　　　\n' +
  '　１１１１　　１１１１１１１１１１１１　　　　　　１１１１１１１１１１１１１１　　　　\n' +
  '　１１１１　　１１　　　　１１　　　　　　　　　　１１１１１１１１１１１１１１　　　　\n' +
  '　　　１１　　１１　１１　１１　　１１１　　　　　　１１　　　１１　　１１１　　　　　\n' +
  '　　　１１　　１１　１１　１１　　１１　　　　　　　１１１　　１１　　１１１　　　　　\n' +
  '　　　１１　１１１　１１　１１　　１１　　　　　　　　１１１　１１　１１１　　　　　　\n' +
  '　１１１１　１１１　１１１１１１１１１　　　　　１１　１１１　１１　１１１１１１１　　\n' +
  '　　１１１１１１　　１１１１１１１１１１　　　　１１１１１１１１１１１１１１１１１　　\n' +
  '　　１１　１１１　　　　　　　　　１１１　　　　１１１１１１１１１１１１１１１１１　　\n' +
  '\n',


  '             ,%%%%%%%%,\n' +
  '           ,%%/\\%%%%/\\%%\n' +
  '          ,%%%\\c "" J/%%%\n' +
  ' %.       %%%%/ o  o \\%%%\n' +
  ' `%%.     %%%%    _  |%%%\n' +
  '  `%%     `%%%%(__Y__)%%\'\n' +
  '  //       ;%%%%`\\-/%%%\'\n' +
  ' ((       /  `%%%%%%%\'\n' +
  '  \\\\    .\'          |\n' +
  '   \\\\  /       \\  | |\n' +
  '    \\\\/         ) | |\n' +
  '     \\         /_ | |__\n' +
  '     (___________))))))) 攻城湿\n' +
  '\n' +
  '        _       _\n' +
  ' __   _(_)_   _(_) __ _ _ __\n' +
  ' \\ \\ / / \\ \\ / / |/ _` |\'_ \\\n' +
  '  \\ V /| |\\ V /| | (_| | | | |\n' +
  '   \\_/ |_| \\_/ |_|\\__,_|_| |_|\n',


  '_______________#########_______________________\n' +
  '______________############_____________________\n' +
  '______________#############____________________\n' +
  '_____________##__###########___________________\n' +
  '____________###__######_#####__________________\n' +
  '____________###_#######___####_________________\n' +
  '___________###__##########_####________________\n' +
  '__________####__###########_####_______________\n' +
  '________#####___###########__#####_____________\n' +
  '_______######___###_########___#####___________\n' +
  '_______#####___###___########___######_________\n' +
  '______######___###__###########___######_______\n' +
  '_____######___####_##############__######______\n' +
  '____#######__#####################_#######_____\n' +
  '____#######__##############################____\n' +
  '___#######__######_#################_#######___\n' +
  '___#######__######_######_#########___######___\n' +
  '___#######____##__######___######_____######___\n' +
  '___#######________######____#####_____#####____\n' +
  '____######________#####_____#####_____####_____\n' +
  '_____#####________####______#####_____###______\n' +
  '______#####______;###________###______#________\n' +
  '________##_______####________####______________\n' +
  '/\n',



  '\n' +
  '                                       ,s555SB@@&                         \n' +
  '                                    :9H####@@@@@Xi                        \n' +
  '                                   1@@@@@@@@@@@@@@8                       \n' +
  '                                 ,8@@@@@@@@@B@@@@@@8                      \n' +
  '                                :B@@@@X3hi8Bs;B@@@@@Ah,                   \n' +
  '           ,8i                  r@@@B:     1S ,M@@@@@@#8;                 \n' +
  '          1AB35.i:               X@@8 .   SGhr ,A@@@@@@@@S                \n' +
  '          1@h31MX8                18Hhh3i .i3r ,A@@@@@@@@@5               \n' +
  '          ;@&i,58r5                 rGSS:     :B@@@@@@@@@@A               \n' +
  '           1#i  . 9i                 hX.  .: .5@@@@@@@@@@@1               \n' +
  '            sG1,  ,G53s.              9#Xi;hS5 3B@@@@@@@B1                \n' +
  '             .h8h.,A@@@MXSs,           #@H1:    3ssSSX@1                  \n' +
  '             s ,@@@@@@@@@@@@Xhi,       r#@@X1s9M8    .GA981               \n' +
  '             ,. rS8H#@@@@@@@@@@#HG51;.  .h31i;9@r    .8@@@@BS;i;          \n' +
  '              .19AXXXAB@@@@@@@@@@@@@@#MHXG893hrX#XGGXM@@@@@@@@@@MS        \n' +
  '              s@@MM@@@hsX#@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@&,      \n' +
  '            :GB@#3G@@Brs ,1GM@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@B,     \n' +
  '          .hM@@@#@@#MX 51  r;iSGAM@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@8     \n' +
  '        :3B@@@@@@@@@@@&9@h :Gs   .;sSXH@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@:    \n' +
  '    s&HA#@@@@@@@@@@@@@@M89A;.8S.       ,r3@@@@@@@@@@@@@@@@@@@@@@@@@@@r    \n' +
  ' ,13B@@@@@@@@@@@@@@@@@@@5 5B3 ;.         ;@@@@@@@@@@@@@@@@@@@@@@@@@@@i    \n' +
  '5#@@#&@@@@@@@@@@@@@@@@@@9  .39:          ;@@@@@@@@@@@@@@@@@@@@@@@@@@@;    \n' +
  '9@@@X:MM@@@@@@@@@@@@@@@#;    ;31.         H@@@@@@@@@@@@@@@@@@@@@@@@@@:    \n' +
  ' SH#@B9.rM@@@@@@@@@@@@@B       :.         3@@@@@@@@@@@@@@@@@@@@@@@@@@5    \n' +
  '   ,:.   9@@@@@@@@@@@#HB5                 .M@@@@@@@@@@@@@@@@@@@@@@@@@B    \n' +
  '         ,ssirhSM@&1;i19911i,.             s@@@@@@@@@@@@@@@@@@@@@@@@@@S   \n' +
  '            ,,,rHAri1h1rh&@#353Sh:          8@@@@@@@@@@@@@@@@@@@@@@@@@#:  \n' +
  '          .A3hH@#5S553&@@#h   i:i9S          #@@@@@@@@@@@@@@@@@@@@@@@@@A.\n' +
  '\n' +
  '\n' +
  '  又看源码，看你妹妹呀！\n',

  ' \n' +
  ' **************************************************************\n' +
  ' *                                                            *\n' +
  ' *   .=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-.       *\n' +
  ' *    |                     ______                     |      *\n' +
  ' *    |                  .-"      "-.                  |      *\n' +
  ' *    |                 /            \\                 |      *\n' +
  ' *    |     _          |              |          _     |      *\n' +
  ' *    |    ( \\         |,  .-.  .-.  ,|         / )    |      *\n' +
  ' *    |     > "=._     | )(__/  \\__)( |     _.=" <     |      *\n' +
  ' *    |    (_/"=._"=._ |/     /\\     \\| _.="_.="\\_)    |      *\n' +
  ' *    |           "=._"(_     ^^     _)"_.="           |      *\n' +
  ' *    |               "=\\__|IIIIII|__/="               |      *\n' +
  ' *    |              _.="| \\IIIIII/ |"=._              |      *\n' +
  ' *    |    _     _.="_.="\\          /"=._"=._     _    |      *\n' +
  ' *    |   ( \\_.="_.="     `--------`     "=._"=._/ )   |      *\n' +
  ' *    |    > _.="                            "=._ <    |      *\n' +
  ' *    |   (_/                                    \\_)   |      *\n' +
  ' *    |                                                |      *\n' +
  ' *    \'-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=\'      *\n' +
  ' *                                                            *\n' +
  ' *           LASCIATE OGNI SPERANZA, VOI CH\'ENTRATE           *\n' +
  ' **************************************************************\n' +
  ' \n',

  ' _._ _..._ .-\',     _.._(`))\n' +
  '\'-. `     \'  /-._.-\'    \',/\n' +
  '   )         \\            \'.\n' +
  '  / _    _    |             \\\n' +
  ' |  a    a    /              |\n' +
  ' \\   .-.                     ;\n' +
  '  \'-(\'\' ).-\'       ,\'       ;\n' +
  '     \'-;           |      .\'\n' +
  '        \\           \\    /\n' +
  '        | 7  .__  _.-\\   \\\n' +
  '        | |  |  ``/  /`  /\n' +
  '       /,_|  |   /,_/   /\n' +
  '          /,_/      \'`-\'\n',


  '\n' +
  '\n' +
  '                                                   __----~~~~~~~~~~~------___\n' +
  '                                  .  .   ~~//====......          __--~ ~~\n' +
  '                  -.            \\_|//     |||\\\\  ~~~~~~::::... /~\n' +
  '               ___-==_       _-~o~  \\/    |||  \\\\            _/~~-\n' +
  '       __---~~~.==~||\\=_    -_--~/_-~|-   |\\\\   \\\\        _/~\n' +
  '   _-~~     .=~    |  \\\\-_    \'-~7  /-   /  ||    \\      /\n' +
  ' .~       .~       |   \\\\ -_    /  /-   /   ||      \\   /\n' +
  '/  ____  /         |     \\\\ ~-_/  /|- _/   .||       \\ /\n' +
  '|~~    ~~|--~~~~--_ \\     ~==-/   | \\~--===~~        .\\\n' +
  '         \'         ~-|      /|    |-~\\~~       __--~~\n' +
  '                     |-~~-_/ |    |   ~\\_   _-~            /\\\n' +
  '                          /  \\     \\__   \\/~                \\__\n' +
  '                      _--~ _/ | .-~~____--~-/                  ~~==.\n' +
  '                     ((->/~   \'.|||\' -_|    ~~-/ ,              . _||\n' +
  '                                -_     ~\\      ~~---l__i__i__i--~~_/\n' +
  '                                _-~-__   ~)  \\--______________--~~\n' +
  '                              //.-~~~-~_--~- |-------~~~~~~~~\n' +
  '                                     //.-~~~--\\\n' +
  '                              神兽保佑\n' +
  '                             代码无BUG!\n' +
  '\n',



  '                 ___====-_  _-====___\n' +
  '           _--^^^#####//      \\\\#####^^^--_\n' +
  '        _-^##########// (    ) \\\\##########^-_\n' +
  '       -############//  |\\^^/|  \\\\############-\n' +
  '     _/############//   (@::@)   \\\\############\\_\n' +
  '    /#############((     \\\\//     ))#############\\\n' +
  '   -###############\\\\    (oo)    //###############-\n' +
  '  -#################\\\\  / VV \\  //#################-\n' +
  ' -###################\\\\/      \\//###################-\n' +
  '_#/|##########/\\######(   /\\   )######/\\##########|\\#_\n' +
  '|/ |#/\\#/\\#/\\/  \\#/\\##\\  |  |  /##/\\#/  \\/\\#/\\#/\\#| \\|\n' +
  '`  |/  V  V  `   V  \\#\\| |  | |/#/  V   \'  V  V  \\|  \'\n' +
  '   `   `  `      `   / | |  | | \\   \'      \'  \'   \'\n' +
  '                    (  | |  | |  )\n' +
  '                   __\\ | |  | | /__\n' +
  '                  (vvv(VVV)(VVV)vvv)                \n' +
  '                       神兽保佑\n' +
  '                      代码无BUG!\n',


  '    ┌─┐       ┌─┐ + +\n' +
  ' ┌──┘ ┴───────┘ ┴──┐++\n' +
  ' │                 │\n' +
  ' │       ───       │++ + + +\n' +
  ' ███████───███████ │+\n' +
  ' │                 │+\n' +
  ' │       ─┴─       │\n' +
  ' │                 │\n' +
  ' └───┐         ┌───┘\n' +
  '     │         │\n' +
  '     │         │   + +\n' +
  '     │         │\n' +
  '     │         └──────────────┐\n' +
  '     │                        │\n' +
  '     │                        ├─┐\n' +
  '     │                        ┌─┘\n' +
  '     │                        │\n' +
  '     └─┐  ┐  ┌───────┬──┐  ┌──┘  + + + +\n' +
  '       │ ─┤ ─┤       │ ─┤ ─┤\n' +
  '       └──┴──┘       └──┴──┘  + + + +\n' +
  '              神兽保佑\n' +
  '             代码无BUG!\n' +
  '\n',


  '    ┌─┐       ┌─┐\n' +
  ' ┌──┘ ┴───────┘ ┴──┐\n' +
  ' │                 │\n' +
  ' │       ───       │\n' +
  ' │   >        <    │\n' +
  ' │                 │\n' +
  ' │   ...  ⌒  ...   │\n' +
  ' │                 │\n' +
  ' └───┐         ┌───┘\n' +
  '     │         │\n' +
  '     │         │\n' +
  '     │         │\n' +
  '     │         └──────────────┐\n' +
  '     │                        │\n' +
  '     │                        ├─┐\n' +
  '     │                        ┌─┘\n' +
  '     │                        │\n' +
  '     └─┐  ┐  ┌───────┬──┐  ┌──┘\n' +
  '       │ ─┤ ─┤       │ ─┤ ─┤\n' +
  '       └──┴──┘       └──┴──┘\n' +
  '              神兽保佑\n' +
  '             代码无BUG!\n' +
  '\n',


  '     ┌─┐       ┌─┐\n' +
  '  ┌──┘ ┴───────┘ ┴──┐\n' +
  '  │                 │\n' +
  '  │       ───       │\n' +
  '  │  ─┬┘       └┬─  │\n' +
  '  │                 │\n' +
  '  │       ─┴─       │\n' +
  '  │                 │\n' +
  '  └───┐         ┌───┘\n' +
  '      │         │\n' +
  '      │         │\n' +
  '      │         │\n' +
  '      │         └──────────────┐\n' +
  '      │                        │\n' +
  '      │                        ├─┐\n' +
  '      │                        ┌─┘\n' +
  '      │                        │\n' +
  '      └─┐  ┐  ┌───────┬──┐  ┌──┘\n' +
  '        │ ─┤ ─┤       │ ─┤ ─┤\n' +
  '        └──┴──┘       └──┴──┘\n' +
  '               神兽保佑\n' +
  '              代码无BUG!\n' +
  '\n',

  '                   .::::.\n' +
  '                 .::::::::.\n' +
  '                :::::::::::  FUCK YOU\n' +
  '            ..:::::::::::\'\n' +
  '          \'::::::::::::\'\n' +
  '            .::::::::::\n' +
  '       \'::::::::::::::..\n' +
  '            ..::::::::::::.\n' +
  '          ``::::::::::::::::\n' +
  '           ::::``:::::::::\'        .:::.\n' +
  '          ::::\'   \':::::\'       .::::::::.\n' +
  '        .::::\'      ::::     .:::::::\'::::.\n' +
  '       .:::\'       :::::  .:::::::::\' \':::::.\n' +
  '      .::\'        :::::.:::::::::\'      \':::::.\n' +
  '     .::\'         ::::::::::::::\'         ``::::.\n' +
  ' ...:::           ::::::::::::\'              ``::.\n' +
  '```` \':.          \':::::::::\'                  ::::..\n' +
  '                   \'.:::::\'                    \':\'````..\n' +
  '\n',


  '\n' +
  '   █████▒█    ██  ▄████▄   ██ ▄█▀       ██████╗ ██╗   ██╗ ██████╗\n' +
  ' ▓██   ▒ ██  ▓██▒▒██▀ ▀█   ██▄█▒        ██╔══██╗██║   ██║██╔════╝\n' +
  ' ▒████ ░▓██  ▒██░▒▓█    ▄ ▓███▄░        ██████╔╝██║   ██║██║  ███╗\n' +
  ' ░▓█▒  ░▓▓█  ░██░▒▓▓▄ ▄██▒▓██ █▄        ██╔══██╗██║   ██║██║   ██║\n' +
  ' ░▒█░   ▒▒█████▓ ▒ ▓███▀ ░▒██▒ █▄       ██████╔╝╚██████╔╝╚██████╔╝\n' +
  '  ▒ ░   ░▒▓▒ ▒ ▒ ░ ░▒ ▒  ░▒ ▒▒ ▓▒       ╚═════╝  ╚═════╝  ╚═════╝\n' +
  '  ░     ░░▒░ ░ ░   ░  ▒   ░ ░▒ ▒░\n' +
  '  ░ ░    ░░░ ░ ░ ░        ░ ░░ ░\n' +
  '           ░     ░ ░      ░  ░\n',


  '_ooOoo_\n' +
  'o8888888o\n' +
  '88" . "88\n' +
  '(| -_- |)\n' +
  ' O\\ = /O\n' +
  '___/`---\'\\____\n' +
  '.   \' \\\\| |// `.\n' +
  '/ \\\\||| : |||// \\\n' +
  '/ _||||| -:- |||||- \\\n' +
  '| | \\\\\\ - /// | |\n' +
  '| \\_| \'\'\\---/\'\' | |\n' +
  '\\ .-\\__ `-` ___/-. /\n' +
  '___`. .\' /--.--\\ `. . __\n' +
  '."" \'< `.___\\_<|>_/___.\' >\'"".\n' +
  '| | : `- \\`.;`\\ _ /`;.`/ - ` : | |\n' +
  '\\ \\ `-. \\_ __\\ /__ _/ .-` / /\n' +
  '======`-.____`-.___\\_____/___.-`____.-\'======\n' +
  '`=---=\'\n' +
  '         .............................................\n' +
  '          佛曰：bug泛滥，我已瘫痪！\n',

  '佛曰:\n' +
  '        写字楼里写字间，写字间里程序员；\n' +
  '        程序人员写程序，又拿程序换酒钱。\n' +
  '        酒醒只在网上坐，酒醉还来网下眠；\n' +
  '        酒醉酒醒日复日，网上网下年复年。\n' +
  '        但愿老死电脑间，不愿鞠躬老板前；\n' +
  '        奔驰宝马贵者趣，公交自行程序员。\n' +
  '        别人笑我忒疯癫，我笑自己命太贱；\n' +
  '        不见满街漂亮妹，哪个归得程序员？\n',



  '                   _ooOoo_\n' +
  '                  o8888888o\n' +
  '                  88" . "88\n' +
  '                  (| -_- |)\n' +
  '                   O\\ = /O\n' +
  '               ____/`---\'\\____\n' +
  '             .   \' \\\\| |// `.\n' +
  '              / \\\\||| : |||// \\\n' +
  '            / _||||| -:- |||||- \\\n' +
  '              | | \\\\\\ - /// | |\n' +
  '            | \\_| \'\'\\---/\'\' | |\n' +
  '             \\ .-\\__ `-` ___/-. /\n' +
  '          ___`. .\' /--.--\\ `. . __\n' +
  '       ."" \'< `.___\\_<|>_/___.\' >\'"".\n' +
  '      | | : `- \\`.;`\\ _ /`;.`/ - ` : | |\n' +
  '        \\ \\ `-. \\_ __\\ /__ _/ .-` / /\n' +
  '======`-.____`-.___\\_____/___.-`____.-\'======\n' +
  '                   `=---=\'\n' +
  '\n' +
  '.............................................\n' +
  '         佛祖保佑             永无BUG\n',


  '┌───┐   ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┐\n' +
  '│Esc│   │ F1│ F2│ F3│ F4│ │ F5│ F6│ F7│ F8│ │ F9│F10│F11│F12│ │P/S│S L│P/B│  ┌┐    ┌┐    ┌┐\n' +
  '└───┘   └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┘  └┘    └┘    └┘\n' +
  '┌───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───────┐ ┌───┬───┬───┐ ┌───┬───┬───┬───┐\n' +
  '│~ `│! 1│@ 2│# 3│$ 4│% 5│^ 6│& 7│* 8│( 9│) 0│_ -│+ =│ BacSp │ │Ins│Hom│PUp│ │N L│ / │ * │ - │\n' +
  '├───┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─────┤ ├───┼───┼───┤ ├───┼───┼───┼───┤\n' +
  '│ Tab │ Q │ W │ E │ R │ T │ Y │ U │ I │ O │ P │{ [│} ]│ | \\ │ │Del│End│PDn│ │ 7 │ 8 │ 9 │   │\n' +
  '├─────┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴─────┤ └───┴───┴───┘ ├───┼───┼───┤ + │\n' +
  '│ Caps │ A │ S │ D │ F │ G │ H │ J │ K │ L │: ;│" \'│ Enter  │               │ 4 │ 5 │ 6 │   │\n' +
  '├──────┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴────────┤     ┌───┐     ├───┼───┼───┼───┤\n' +
  '│ Shift  │ Z │ X │ C │ V │ B │ N │ M │< ,│> .│? /│  Shift   │     │ ↑ │     │ 1 │ 2 │ 3 │   │\n' +
  '├─────┬──┴─┬─┴──┬┴───┴───┴───┴───┴───┴──┬┴───┼───┴┬────┬────┤ ┌───┼───┼───┐ ├───┴───┼───┤ E││\n' +
  '│ Ctrl│    │Alt │         Space         │ Alt│    │    │Ctrl│ │ ← │ ↓ │ → │ │   0   │ . │←─┘│\n' +
  '└─────┴────┴────┴───────────────────────┴────┴────┴────┴────┘ └───┴───┴───┘ └───────┴───┴───┘\n',



  '           .,,       .,:;;iiiiiiiii;;:,,.     .,,              \n' +
  '         rGB##HS,.;iirrrrriiiiiiiiiirrrrri;,s&##MAS,           \n' +
  '        r5s;:r3AH5iiiii;;;;;;;;;;;;;;;;iiirXHGSsiih1,          \n' +
  '           .;i;;s91;;;;;;::::::::::::;;;;iS5;;;ii:             \n' +
  '         :rsriii;;r::::::::::::::::::::::;;,;;iiirsi,          \n' +
  '      .,iri;;::::;;;;;;::,,,,,,,,,,,,,..,,;;;;;;;;iiri,,.      \n' +
  '   ,9BM&,            .,:;;:,,,,,,,,,,,hXA8:            ..,,,.  \n' +
  '  ,;&@@#r:;;;;;::::,,.   ,r,,,,,,,,,,iA@@@s,,:::;;;::,,.   .;. \n' +
  '   :ih1iii;;;;;::::;;;;;;;:,,,,,,,,,,;i55r;;;;;;;;;iiirrrr,..  \n' +
  '  .ir;;iiiiiiiiii;;;;::::::,,,,,,,:::::,,:;;;iiiiiiiiiiiiri    \n' +
  '  iriiiiiiiiiiiiiiii;;;::::::::::::::::;;;iiiiiiiiiiiiiiiir;   \n' +
  ' ,riii;;;;;;;;;;;;;:::::::::::::::::::::::;;;;;;;;;;;;;;iiir.  \n' +
  ' iri;;;::::,,,,,,,,,,:::::::::::::::::::::::::,::,,::::;;iir:  \n' +
  '.rii;;::::,,,,,,,,,,,,:::::::::::::::::,,,,,,,,,,,,,::::;;iri  \n' +
  ',rii;;;::,,,,,,,,,,,,,:::::::::::,:::::,,,,,,,,,,,,,:::;;;iir. \n' +
  ',rii;;i::,,,,,,,,,,,,,:::::::::::::::::,,,,,,,,,,,,,,::i;;iir. \n' +
  ',rii;;r::,,,,,,,,,,,,,:,:::::,:,:::::::,,,,,,,,,,,,,::;r;;iir. \n' +
  '.rii;;rr,:,,,,,,,,,,,,,,:::::::::::::::,,,,,,,,,,,,,:,si;;iri  \n' +
  ' ;rii;:1i,,,,,,,,,,,,,,,,,,:::::::::,,,,,,,,,,,,,,,:,ss:;iir:  \n' +
  ' .rii;;;5r,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,sh:;;iri   \n' +
  '  ;rii;:;51,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,.:hh:;;iir,   \n' +
  '   irii;::hSr,.,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,.,sSs:;;iir:    \n' +
  '    irii;;:iSSs:.,,,,,,,,,,,,,,,,,,,,,,,,,,,..:135;:;;iir:     \n' +
  '     ;rii;;:,r535r:...,,,,,,,,,,,,,,,,,,..,;sS35i,;;iirr:      \n' +
  '      :rrii;;:,;1S3Shs;:,............,:is533Ss:,;;;iiri,       \n' +
  '       .;rrii;;;:,;rhS393S55hh11hh5S3393Shr:,:;;;iirr:         \n' +
  '         .;rriii;;;::,:;is1h555555h1si;:,::;;;iirri:.          \n' +
  '           .:irrrii;;;;;:::,,,,,,,,:::;;;;iiirrr;,             \n' +
  '              .:irrrriiiiii;;;;;;;;iiiiiirrrr;,.               \n' +
  '                 .,:;iirrrrrrrrrrrrrrrrri;:.                   \n' +
  '                       ..,:::;;;;:::,,.                        \n' +
  '                                                               \n',


  '              ii.                                         ;9ABH,          \n' +
  '             SA391,                                    .r9GG35&G          \n' +
  '             &#ii13Gh;                               i3X31i;:,rB1         \n' +
  '             iMs,:,i5895,                         .5G91:,:;:s1:8A         \n' +
  '              33::::,,;5G5,                     ,58Si,,:::,sHX;iH1        \n' +
  '               Sr.,:;rs13BBX35hh11511h5Shhh5S3GAXS:.,,::,,1AG3i,GG        \n' +
  '               .G51S511sr;;iiiishS8G89Shsrrsh59S;.,,,,,..5A85Si,h8        \n' +
  '              :SB9s:,............................,,,.,,,SASh53h,1G.       \n' +
  '           .r18S;..,,,,,,,,,,,,,,,,,,,,,,,,,,,,,....,,.1H315199,rX,       \n' +
  '         ;S89s,..,,,,,,,,,,,,,,,,,,,,,,,....,,.......,,,;r1ShS8,;Xi       \n' +
  '       i55s:.........,,,,,,,,,,,,,,,,.,,,......,.....,,....r9&5.:X1       \n' +
  '      59;.....,.     .,,,,,,,,,,,...        .............,..:1;.:&s       \n' +
  '     s8,..;53S5S3s.   .,,,,,,,.,..      i15S5h1:.........,,,..,,:99       \n' +
  '     93.:39s:rSGB@A;  ..,,,,.....    .SG3hhh9G&BGi..,,,,,,,,,,,,.,83      \n' +
  '     G5.G8  9#@@@@@X. .,,,,,,.....  iA9,.S&B###@@Mr...,,,,,,,,..,.;Xh     \n' +
  '     Gs.X8 S@@@@@@@B:..,,,,,,,,,,. rA1 ,A@@@@@@@@@H:........,,,,,,.iX:    \n' +
  '    ;9. ,8A#@@@@@@#5,.,,,,,,,,,... 9A. 8@@@@@@@@@@M;    ....,,,,,,,,S8    \n' +
  '    X3    iS8XAHH8s.,,,,,,,,,,...,..58hH@@@@@@@@@Hs       ...,,,,,,,:Gs   \n' +
  '   r8,        ,,,...,,,,,,,,,,.....  ,h8XABMMHX3r.          .,,,,,,,.rX:  \n' +
  '  :9, .    .:,..,:;;;::,.,,,,,..          .,,.               ..,,,,,,.59  \n' +
  ' .Si      ,:.i8HBMMMMMB&5,....                    .            .,,,,,.sMr\n' +
  ' SS       :: h@@@@@@@@@@#; .                     ...  .         ..,,,,iM5\n' +
  ' 91  .    ;:.,1&@@@@@@MXs.                            .          .,,:,:&S\n' +
  ' hS ....  .:;,,,i3MMS1;..,..... .  .     ...                     ..,:,.99\n' +
  ' ,8; ..... .,:,..,8Ms:;,,,...                                     .,::.83\n' +
  '  s&: ....  .sS553B@@HX3s;,.    .,;13h.                            .:::&1\n' +
  '   SXr  .  ...;s3G99XA&X88Shss11155hi.                             ,;:h&,\n' +
  '    iH8:  . ..   ,;iiii;,::,,,,,.                                 .;irHA  \n' +
  '     ,8X5;   .     .......                                       ,;iihS8Gi\n' +
  '        1831,                                                 .,;irrrrrs&@\n' +
  '          ;5A8r.                                            .:;iiiiirrss1H\n' +
  '            :X@H3s.......                                .,:;iii;iiiiirsrh\n' +
  '             r#h:;,...,,.. .,,:;;;;;:::,...              .:;;;;;;iiiirrss1\n' +
  '            ,M8 ..,....,.....,,::::::,,...         .     .,;;;iiiiiirss11h\n' +
  '            8B;.,,,,,,,.,.....          .           ..   .:;;;;iirrsss111h\n' +
  '           i@5,:::,,,,,,,,.... .                   . .:::;;;;;irrrss111111\n' +
  '           9Bi,:,,,,......                        ..r91;;;;;iirrsss1ss1111\n',


  '                                                                         \n' +
  '        .,:,,,                                        .::,,,::.          \n' +
  '      .::::,,;;,                                  .,;;:,,....:i:         \n' +
  '      :i,.::::,;i:.      ....,,:::::::::,....   .;i:,.  ......;i.        \n' +
  '      :;..:::;::::i;,,:::;:,,,,,,,,,,..,.,,:::iri:. .,:irsr:,.;i.        \n' +
  '      ;;..,::::;;;;ri,,,.                    ..,,:;s1s1ssrr;,.;r,        \n' +
  '      :;. ,::;ii;:,     . ...................     .;iirri;;;,,;i,        \n' +
  '      ,i. .;ri:.   ... ............................  .,,:;:,,,;i:        \n' +
  '      :s,.;r:... ....................................... .::;::s;        \n' +
  '      ,1r::. .............,,,.,,:,,........................,;iir;        \n' +
  '      ,s;...........     ..::.,;:,,.          ...............,;1s        \n' +
  '     :i,..,.              .,:,,::,.          .......... .......;1,       \n' +
  '    ir,....:rrssr;:,       ,,.,::.     .r5S9989398G95hr;. ....,.:s,      \n' +
  '   ;r,..,s9855513XHAG3i   .,,,,,,,.  ,S931,.,,.;s;s&BHHA8s.,..,..:r:     \n' +
  '  :r;..rGGh,  :SAG;;G@BS:.,,,,,,,,,.r83:      hHH1sXMBHHHM3..,,,,.ir.    \n' +
  ' ,si,.1GS,   sBMAAX&MBMB5,,,,,,:,,.:&8       3@HXHBMBHBBH#X,.,,,,,,rr    \n' +
  ' ;1:,,SH:   .A@&&B#&8H#BS,,,,,,,,,.,5XS,     3@MHABM&59M#As..,,,,:,is,   \n' +
  '.rr,,,;9&1   hBHHBB&8AMGr,,,,,,,,,,,:h&&9s;   r9&BMHBHMB9:  . .,,,,;ri.  \n' +
  ':1:....:5&XSi;r8BMBHHA9r:,......,,,,:ii19GG88899XHHH&GSr.      ...,:rs.  \n' +
  ';s.     .:sS8G8GG889hi.        ....,,:;:,.:irssrriii:,.        ...,,i1,  \n' +
  ';1,         ..,....,,isssi;,        .,,.                      ....,.i1,  \n' +
  ';h:               i9HHBMBBHAX9:         .                     ...,,,rs,  \n' +
  ',1i..            :A#MBBBBMHB##s                             ....,,,;si.  \n' +
  '.r1,..        ,..;3BMBBBHBB#Bh.     ..                    ....,,,,,i1;   \n' +
  ' :h;..       .,..;,1XBMMMMBXs,.,, .. :: ,.               ....,,,,,,ss.   \n' +
  '  ih: ..    .;;;, ;;:s58A3i,..    ,. ,.:,,.             ...,,,,,:,s1,    \n' +
  '  .s1,....   .,;sh,  ,iSAXs;.    ,.  ,,.i85            ...,,,,,,:i1;     \n' +
  '   .rh: ...     rXG9XBBM#M#MHAX3hss13&&HHXr         .....,,,,,,,ih;      \n' +
  '    .s5: .....    i598X&&A&AAAAAA&XG851r:       ........,,,,:,,sh;       \n' +
  '    . ihr, ...  .         ..                    ........,,,,,;11:.       \n' +
  '       ,s1i. ...  ..,,,..,,,.,,.,,.,..       ........,,.,,.;s5i.         \n' +
  '        .:s1r,......................       ..............;shs,           \n' +
  '        . .:shr:.  ....                 ..............,ishs.             \n' +
  '            .,issr;,... ...........................,is1s;.               \n' +
  '               .,is1si;:,....................,:;ir1sr;,                  \n' +
  '                  ..:isssssrrii;::::::;;iirsssssr;:..                    \n' +
  '                       .,::iiirsssssssssrri;;:.                      \n',


 '　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　\n' +
 '　　　　瓦瓦　　　　　　　　　　　　十　　　　　　　　　　　　　\n' +
 '　　　十齱龠己　　　　　　　　　亅瓦車己　　　　　　　　　　　　\n' +
 '　　　乙龍龠毋日丶　　　　　　丶乙己毋毋丶　　　　　　　　　　　\n' +
 '　　　十龠馬鬼車瓦　　　　　　己十瓦毋毋　　　　　　　　　　　　\n' +
 '　　　　鬼馬龠馬龠十　　　　己己毋車毋瓦　　　　　　　　　　　　\n' +
 '　　　　毋龠龠龍龠鬼乙丶丶乙車乙毋鬼車己　　　　　　　　　　　　\n' +
 '　　　　乙龠龍龍鬼龍瓦　十瓦毋乙瓦龠瓦亅　　　　　　　　　　　　\n' +
 '　　　　　馬齱龍馬鬼十丶日己己己毋車乙丶　　　　　　　　　　　　\n' +
 '　　　　　己齱馬鬼車十十毋日乙己己乙乙　　　　　　　　　　　　　\n' +
 '　　　　　　車馬齱齱日乙毋瓦己乙瓦日亅　　　　　　　　　　　　　\n' +
 '　　　　　　亅車齺龖瓦乙車龖龍乙乙十　　　　　　　　　　　　　　\n' +
 '　　　　　　　日龠龠十亅車龍毋十十　　　　　　　　　　　　　　　\n' +
 '　　　　　　　日毋己亅　己己十亅亅　　　　　　　　　　　　　　　\n' +
 '　　　　　　丶己十十乙　　丶丶丶丶丶　　　　　　　　　　　　　　\n' +
 '　　　　　　亅己十龍龖瓦　　丶　丶　乙十　　　　　　　　　　　　\n' +
 '　　　　　　亅己十龠龖毋　丶丶　　丶己鬼鬼瓦亅　　　　　　　　　\n' +
 '　　　　　　十日十十日亅丶亅丶　丶十日毋鬼馬馬車乙　　　　　　　\n' +
 '　　　　　　十日乙十亅亅亅丶　　十乙己毋鬼鬼鬼龍齺馬乙　　　　　\n' +
 '　　　　　　丶瓦己乙十十亅丶亅乙乙乙己毋鬼鬼鬼龍齱齺齺鬼十　　　\n' +
 '　　　　　　　乙乙十十十亅乙瓦瓦己日瓦毋鬼鬼龠齱齱龍龍齱齱毋丶　\n' +
 '　　　　　　　亅十十十十乙瓦車毋瓦瓦日車馬龠龍龍龍龍龍龠龠龠馬亅\n' +
 '　　　　　　　　十十十十己毋車瓦瓦瓦瓦鬼馬龠龍龠龠龍龠龠龠馬龠車\n' +
 '　　　　　　　　　亅十十日毋瓦日日瓦鬼鬼鬼龠龠馬馬龠龍龍龠馬馬車\n' +
 '　　　　　　　　　亅亅亅乙瓦瓦毋車車車馬龍龠鬼鬼馬龠龍龍龠馬馬鬼\n' +
 '　　　　　　　丶丶乙亅亅乙車鬼鬼鬼毋車龍龍龠鬼馬馬龠龍齱齱龍馬鬼\n' +
 '　　　　　　亅己十十己十日鬼鬼車瓦毋龠龍龠馬馬龠龠龠齱齺齺齱龠鬼\n' +
 '　　　　　　　亅乙乙乙十車馬車毋馬齱齱龍龠龠龠馬龠龍齱龍龠龠鬼瓦\n' +
 '　　　　　　　　　　　丶毋龠鬼車瓦車馬龠龍龠龠龍齱齱龠馬馬鬼毋日\n' +
 '　　　　　　　　　　　十乙己日十　　丶己鬼龍齱齺齱龍馬馬馬車毋己\n' +
 '　　　　　　　　　丶十己乙亅丶　　　　　　亅瓦馬龠龍龠龠馬毋瓦乙\n' +
 '　　　　　　　　丶十十乙亅十　　　　　　　　亅己瓦車馬龠鬼車瓦乙\n' +
 '　　　　　　　　丶十乙十十丶　　　　　　　　　丶丶亅十瓦鬼車瓦己\n' +
 '　　　　　　　　　丶亅亅丶　　　　　　　　　　　　　　　亅日瓦日\n' +
 '　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　丶\n'
]



export default logos
